module.exports = __webpack_public_path__ + "img/INTERIOR-SCROSS-4.4071905e.jpg";